import angular from "angular";

angular
    .module('ui-sentinel.shipments.shipmentAdmin')
    .controller('ShipmentAdminController', ShipmentAdminController);

ShipmentAdminController.$inject = ['$rootScope', '$scope', '$timeout', '$state', '$stateParams', '$http', 'AlarmContactsService', 'ShipmentsService', 'ShipmentEditorService', 'SentinelUiSession', 'FeedbackService', 'LatestShipmentTrackingReportsService', 'DevicesService', 'SentryAccountApiService', 'SentinelAccountApiService', 'PolygonGeofencesService', 'RadialGeofencesService', 'DatetimeValidatorService', 'ShipmentTrackingUrlBuilderService', 'HideShipmentStopTimes'];

function ShipmentAdminController($rootScope, $scope, $timeout, $state, $stateParams, $http, AlarmContactsService, ShipmentsService, ShipmentEditorService, SentinelUiSession, FeedbackService, LatestShipmentTrackingReportsService, DevicesService, SentryAccountApiService, SentinelAccountApiService, PolygonGeofencesService, RadialGeofencesService, DatetimeValidatorService, ShipmentTrackingUrlBuilderService, HideShipmentStopTimes) {
    const vm = {
        hideShipmentStopTimes: HideShipmentStopTimes,
        availableDevices: [],
        availableSentinels: [],
        availableGeofences: [],
        shipmentAlarms: [],
        deviceSearchText: null,
        endGeofenceSearchText: null,
        endGeofence2SearchText: null,
        beginGeofenceSearchText: null,
        sentinelSearchText: null,
        showSentinels: false,
        isCompleting: false,
        endGeofenceFilter: endGeofenceFilter,
        endGeofence2Filter: endGeofence2Filter,
        beginGeofenceFilter: beginGeofenceFilter,
        endGeofenceNameText: null,
        endGeofence2NameText: null,
        beginGeofenceNameText: null,
        deviceFilter: deviceFilter,
        editor: ShipmentEditorService,
        feedback: FeedbackService,
        listLimit: 5,
        filterSentrysTimeout: null,
        filterSentinelsTimeout: null,
        changeSentryFilter: changeSentryFilter,
        sentinelFilter: sentinelFilter,
        isOrs: $rootScope.isOrs,
        isOrsTopLevel: undefined,
        isFocused: undefined,
        orsSubAccountHide: () => {
            return vm.isOrsTopLevel && vm.isFocused;
        },
        sentriesInitialized: false,
        sentinelsInitialized: false,
        isAiTracking: SentinelUiSession.focus.isFocused ? SentinelUiSession.focus.isAiTracking : SentinelUiSession.user.isAiTracking,
        trackingDeviceLabel: $rootScope.isOrs ? 'GPS Tracker' : 'Tracking device',
        mode: {
            isEditingDevice: false
        },
        hasPermission: {
            toChange: false
        },
        sentry_scan_options: {
            minLength: 15,
            avgTimeByChar: 10,
            onComplete: function () {
                console.log("sentry_scan_options", vm.deviceSearchText);
                vm.changeSentryFilter(vm.deviceSearchText, true);
            }
        },
        sentinel_scan_options: {
            minLength: 12,
            avgTimeByChar: 10,
            onComplete: function () {
                console.log("sentinel", vm.sentinelSearchText);
                vm.sentinelFilter(vm.sentinelSearchText, true);
            }
        },
        contacts: [],
        useContactPicker: false,
        actions: {
            close: close,
            reset: reset,
            submit: submit,
            presubmit: presubmit,
            cancelsubmit: cancelsubmit,
            selectDevice: selectDevice,
            clearDevice: clearDevice,
            selectSentinel: selectSentinel,
            removeSentinel: removeSentinel,
            clearSentinel: clearSentinel,
            cancelShipment: cancelShipment,
            completeShipment: completeShipment,
            goToShipmentMap: goToShipmentMap,
            clearEndGeofence: clearEndGeofence,
            clearEndGeofence2: clearEndGeofence2,
            clearBeginGeofence: clearBeginGeofence,
            selectEndGeofence: selectEndGeofence,
            selectEndGeofence2: selectEndGeofence2,
            selectBeginGeofence: selectBeginGeofence,
            goToShipmentReports: goToShipmentReports,
            openShipmentTrackingPageAsNewTab: openShipmentTrackingPageAsNewTab
        }
    };
    activate();
    vm.readOnly = () => !vm.hasPermission.toChange || !vm.editor.canEdit;
    vm.useContactPicker = () => vm.isOrs && !vm.readOnly();
    return vm;

    function activate() {
        vm.feedback.clear();

        $rootScope.$on('CLIENT_FOCUS_CHANGED', function (event, args) {
            if ($state.current.name == 'shipment.admin') {
                $rootScope.isAiShipment = false;
                $state.go('shipments.list');
            }
        });

        $scope.$on('$destroy', function () {
            $rootScope.isAiShipment = false;
        });

        setPermissions();

        vm.editor.init();

        loadContacts();
        loadGeofences();
        load();

        $scope.$watch(
            function () {
                return LatestShipmentTrackingReportsService.reports;
            },
            function (value) {
                onReportsChange(value);
            }, true
        );
        $scope.$watch(
            function () {
                return ShipmentEditorService.device.value;
            },
            function (value) {
                onDeviceChange();
            }, true
        );
        $scope.$watch(
            function () {
                return ShipmentEditorService.endGeofence.value;
            },
            function (value) {
                onEndGeofenceChange();
            }, true
        );
        $scope.$watch(
            function () {
                return ShipmentEditorService.endGeofence2.value;
            },
            function (value) {
                onEndGeofence2Change();
            }, true
        );
        $scope.$watch(
            function () {
                return ShipmentEditorService.beginGeofence.value;
            },
            function (value) {
                onBeginGeofenceChange();
            }, true
        );
        $scope.$watch(
            function () {
                return SentinelUiSession.focus?.trackingConfig;
            },
            function (value) {
                vm.editor.referencePrefix = value && value.referencePrefix ? value.referencePrefix : null;
            }, true
        );
        $scope.$watch(
            function () {
                return SentinelUiSession.focus;
            },
            function (focus) {
                vm.isFocused = focus ? focus.isFocused : undefined;
            }
        );
        $scope.$watch(
            function () {
                return SentinelUiSession.user;
            },
            function (user) {
                vm.isOrsTopLevel = user ? user.isOrsTopLevel : undefined;
            }
        );
    }

    function cancelShipment() {
        if (!vm.editor.canEdit) {
            vm.feedback.addError('Shipment can not be changed');
            return null;
        }
        vm.feedback.clear();

        const promise = ShipmentsService.cancelShipment(vm.editor.shipment.shipmentInfo.shipmentId).$promise;
        promise.then(
            function (result) {
                const referenceNumber = vm.editor.referencePrefix ? vm.editor.referencePrefix + vm.editor.referenceNumber.value : vm.editor.referenceNumber.value;
                vm.feedback.addSuccess('Shipment ' + referenceNumber + ' has been cancelled');
                vm.editor.shipment.shipmentInfo.status = 'Cancelled';
                vm.editor.canEdit = false;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function changeSentryFilter(filter, forScanner) {
        if (!filter) {
            filter = "";
        }

        filter = filter.replace(/\//g, '');

        console.log("changeSentryFilter", filter);

        $rootScope.loading = true;
        const promise = SentryAccountApiService.getDevicesForASML(SentinelUiSession.focus, filter).$promise;

        promise.then(
            function (result) {
                console.log("Sentries", result);
                vm.availableDevices = result;
                if (result && result.length == 1 && forScanner && forScanner === true) {
                    vm.actions.selectDevice(result[0]);
                    document.getElementById("addSentinelInput").focus();
                } else if (result && result.length == 0 && forScanner && forScanner === true) {
                    vm.deviceSearchText = "";
                }
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
            vm.sentriesInitialized = true;
        });

    }

    function endGeofenceFilter(geofence) {
        if (vm.endGeofenceSearchText === null || vm.endGeofenceSearchText === '') {
            return true;
        }

        const text = vm.endGeofenceSearchText.toLowerCase();
        return geofence.name.toLowerCase().indexOf(text) >= 0;
    }

    function endGeofence2Filter(geofence) {
        if (vm.endGeofence2SearchText === null || vm.endGeofence2SearchText === '') {
            return true;
        }

        const text = vm.endGeofence2SearchText.toLowerCase();
        return geofence.name.toLowerCase().indexOf(text) >= 0;
    }

    function beginGeofenceFilter(geofence) {
        if (vm.beginGeofenceSearchText === null || vm.beginGeofenceSearchText === '') {
            return true;
        }

        const text = vm.beginGeofenceSearchText.toLowerCase();
        return geofence.name.toLowerCase().indexOf(text) >= 0;
    }

    function loadContacts() {
        const promise = (SentinelUiSession.user.accountId == SentinelUiSession.focus.id) ?
            AlarmContactsService.getContacts().$promise :
            AlarmContactsService.getContactsForClient(SentinelUiSession.focus).$promise;

        $rootScope.loading = true;
        promise.then(
            function (result) {
                vm.contacts = result;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function loadGeofences() {
        vm.availableGeofences = [];
        const polygonPromise = PolygonGeofencesService.getGeofences(SentinelUiSession.focus).$promise;
        polygonPromise.then(
            function (result) {
                vm.availableGeofences = vm.availableGeofences.concat(result);
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
        const radialPromise = RadialGeofencesService.getGeofences(SentinelUiSession.focus).$promise;
        radialPromise.then(
            function (result) {
                vm.availableGeofences = vm.availableGeofences.concat(result);
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function selectDevice(device) {
        vm.editor.device.isPristine = false;
        vm.editor.device.value = device;
        vm.deviceNameText = device.imei;

        if (device.friendlyName) {
            vm.deviceNameText = device.friendlyName + " [" + device.imei + "]";
        }
    }

    function selectEndGeofence(g) {
        vm.editor.endGeofence.isPristine = false;
        vm.editor.endGeofence.value = g;
        vm.endGeofenceNameText = g.name + ", " + g.address + "(" + g.type + ")";
    }

    function selectEndGeofence2(g) {
        vm.editor.endGeofence2.isPristine = false;
        vm.editor.endGeofence2.value = g;
        vm.endGeofence2NameText = g.name + ", " + g.address + "(" + g.type + ")";
        vm.editor.endGeofence2.errors.isBlank = false;
        vm.editor.endGeofence2.errors.thisOrLight = false;
        vm.editor.arrivalLightLevel.errors.thisOrGeofence = false;
    }

    function selectBeginGeofence(g) {
        vm.editor.beginGeofence.isPristine = false;
        vm.editor.beginGeofence.value = g;
        vm.beginGeofenceNameText = g.name + ", " + g.address + "(" + g.type + ")";
    }

    function clearDevice() {
        vm.mode.isEditingDevice = true;
        vm.editor.device.value = null;
        vm.editor.device.isPristine = true;

        loadDevices();
    }

    function clearEndGeofence() {
        vm.editor.endGeofence.value = null;
        vm.editor.endGeofence.isPristine = true;
    }

    function clearEndGeofence2() {
        vm.editor.endGeofence2.value = null;
        vm.editor.endGeofence2.isPristine = true;
    }

    function clearBeginGeofence() {
        vm.editor.beginGeofence.value = null;
        vm.editor.beginGeofence.isPristine = true;
    }

    function selectSentinel(sentinel) {
        const exists = _.find(vm.editor.sentinels, function (s) {
            return s.deviceId === sentinel.deviceId;
        });
        if (!exists)
            vm.editor.sentinels.push(sentinel);
    }

    function removeSentinel(sentinel, $index) {
        vm.editor.sentinels.splice($index, 1);
    }

    function clearSentinel() {
        vm.editor.sentinels = [];
    }

    function close() {
        vm.editor.clear();
        $rootScope.isAiShipment = false;
        $state.go($stateParams.referrer, $stateParams.referrerParams);
    }

    function completeShipment() {
        if (!vm.editor.canEdit) {
            vm.feedback.addError('Shipment can not be changed');
            return null;
        }
        vm.feedback.clear();

        const promise = ShipmentsService.completeShipment(vm.editor.shipment.shipmentInfo.shipmentId).$promise;
        promise.then(
            function (result) {
                const referenceNumber = vm.editor.referencePrefix ? vm.editor.referencePrefix + vm.editor.referenceNumber.value : vm.editor.referenceNumber.value;
                vm.feedback.addSuccess('Shipment ' + referenceNumber + ' has been completed manually');
                vm.editor.shipment.shipmentInfo.status = 'Completed';
                vm.editor.canEdit = false;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function sentinelFilter(filter, forScanner) {
        if (!filter) {
            filter = "";
        }

        filter = filter.replace(/\//g, '');

        console.log("sentinelFilter", filter);

        $rootScope.loading = true;
        const promise = SentinelAccountApiService.getSentinelsForASML(SentinelUiSession.focus, filter).$promise;

        promise.then(
            function (result) {
                console.log("Sentinels", result);
                vm.availableSentinels = result;
                if (result && result.length === 1 && forScanner && forScanner === true) {
                    vm.actions.selectSentinel(result[0]);
                    vm.sentinelSearchText = "";
                } else if (result && result.length === 0 && forScanner && forScanner === true) {
                    vm.sentinelSearchText = "";
                }
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
            vm.sentinelsInitialized = true;
        });

    }

    function deviceFilter(device) {
        if (vm.deviceSearchText === null || vm.deviceSearchText === '') {
            return true;
        }

        const text = vm.deviceSearchText.toLowerCase();
        return device.deviceTagId.indexOf(text) >= 0 || device.deviceName.toLowerCase().indexOf(text) >= 0;
    }

    function goToShipmentMap() {
        if (vm.editor.shipment) {
            $state.go('shipment.map', {
                shipmentId: vm.editor.shipment.shipmentInfo.shipmentId,
                referrer: 'shipments.reports'
            });
        }
    }

    function goToShipmentReports() {
        if (vm.editor.shipment) {
            $state.go('shipment.reports', {
                shipmentId: vm.editor.shipment.shipmentInfo.shipmentId,
                referrer: 'shipments.reports'
            });
        }
    }

    async function openShipmentTrackingPageAsNewTab() {
        await ShipmentTrackingUrlBuilderService.openShipmentTrackingPageAsNewTab(vm.editor.shipment.shipmentInfo);
    }

    function toTimeZone(date, timeZone) {
        return moment.utc(date).tz(timeZone);
    }

    function load() {
        $rootScope.loading = true;
        const promise = ShipmentsService.getShipment($stateParams.shipmentId).$promise;
        promise.then(
            function (result) {
                const shipment = result;
                if (shipment.shipmentStops) {
                    for (const stop of shipment.shipmentStops) {
                        vm.editor.shipmentStopAddUiProperties(stop);
                    }
                }
                vm.editor.edit(shipment);
                $state.current.data.subTitle = vm.editor.shipment.shipmentInfo.referenceNumber;
                $rootScope.isAiShipment = vm.editor.isAiShipment;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            loadSentinels();
        });
    }

    function loadDevices() {
        $rootScope.loading = true;
        vm.availableDevices = [];

        const promise = SentryAccountApiService.getDevicesForASML(SentinelUiSession.focus, "").$promise;

        promise.then(
            function (result) {
                vm.availableDevices = result;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function loadSentinels() {
        vm.availableSentinels = [];
        const promise = SentinelAccountApiService.getSentinelsForASML(SentinelUiSession.focus, "").$promise;
        promise.then(
            function (result) {
                vm.availableSentinels = result;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function onDeviceChange() {
        if (vm.editor.device.value === null) {
            vm.deviceNameText = null;
            return;
        }

        vm.deviceNameText = vm.editor.device.value?.imei || vm.editor.shipment.shipmentInfo.deviceTagId;

        if (vm.editor.device.value?.friendlyName) {
            vm.deviceNameText = vm.editor.device.value.friendlyName + " [" + vm.editor.device.value.imei + "]";
        }
    }

    function onEndGeofenceChange() {
        if (vm.editor.endGeofence.value === null) {
            vm.endGeofenceNameText = null;
            return;
        }

        const geofence = vm.editor.endGeofence.value;
        vm.endGeofenceNameText = geofence.name + ", " + geofence.address + "(" + geofence.type + ")";
    }

    function onEndGeofence2Change() {
        if (vm.editor.endGeofence2.value === null) {
            vm.endGeofence2NameText = null;
            return;
        }

        const geofence = vm.editor.endGeofence2.value;
        vm.endGeofence2NameText = geofence.name + ", " + geofence.address + "(" + geofence.type + ")";
    }

    function onBeginGeofenceChange(g) {
        if (vm.editor.beginGeofence.value === null) {
            vm.beginGeofenceNameText = null;
            return;
        }

        const geofence = vm.editor.beginGeofence.value;
        vm.beginGeofenceNameText = geofence.name + ", " + geofence.address + "(" + geofence.type + ")";
    }

    function onReportsChange() {
        _.forEach(vm.availableDevices, function (device) {
            device.lastReport = {
                age: null,
                battery: null,
                location: null,
                isOnShipment: null
            };

            _.forEach(LatestShipmentTrackingReportsService.reports, function (report) {
                if (report.deviceTagId === device.deviceTagId) {
                    device.lastReport.age = moment(report.serverTimeStamp).toNow();
                    device.lastReport.battery = report.batteryPercent;
                    return false;
                }
            });
        });
    }

    function reset() {
        vm.mode.isEditingDevice = false;
        vm.editor.reset();

        if (!vm.editor.shipment) {
            $state.current.data.subTitle = null;
        } else {
            $state.current.data.subTitle = vm.editor.shipment.shipmentInfo.referenceNumber;
        }
    }

    function setPermissions() {
        vm.hasPermission.toChange =
            SentinelUiSession.user.isSystemAdmin ||
            SentinelUiSession.user.isAccountAdmin ||
            SentinelUiSession.user.isAccountEditor;
    }

    function cancelsubmit() {
        vm.isCompleting = false;
    }

    function presubmit() {
        vm.editor.preSaveShipmentInfo().then(function (shipmentInfoToUpdate) {
            if (vm.editor.shipment.shipmentInfo.status === "Overdue" && shipmentInfoToUpdate &&
                shipmentInfoToUpdate.status === "Complete") {
                vm.isCompleting = true;

            } else {
                vm.isCompleting = false;
                if (shipmentInfoToUpdate) {
                    submit();
                }
            }
        });
    }

    function submit() {
        vm.feedback.clear();

        $rootScope.loading = true;
        vm.editor.saveShipmentInfo().then(function (result) {
            if (!result) {
                return;
            }

            result.$promise.then(
                function (result) {
                    const referenceNumber = vm.editor.referencePrefix ? vm.editor.referencePrefix + vm.editor.referenceNumber.value : vm.editor.referenceNumber.value;
                    vm.editor.shipment.shipmentInfo = result;
                    vm.feedback.addSuccess('Shipment ' + referenceNumber + ' has been saved');

                },
                function (error) {
                    console.log(error);
                    vm.feedback.addErrorFromError(error);
                }
            ).finally(function () {
                $rootScope.loading = false;
                vm.isCompleting = false;
            });
        });
    }
}
